<template>
  <div class="student">
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <div class="table-agile-info">
            <jm-crumbs/>
            <el-form
              :model="formData"
              :rules="rules"
              class="formData"
              label-width="7em">
              <jm-form-options
                :options="options"
                :option-data="formData"
                :const-dict="constDict"/>
              <el-form-item>
                <el-button
                  type="primary"
                  @click="reset">重置</el-button>
                <el-button
                  type="primary"
                  @click="save">保存</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import jmFormOptions from '@/components/data/formOptions';

const options = [
  {
    visible: 'act_title',
    field: 'act_title',
    label: '活动名称',
    placeholder: '活动名称',
    component: 'input',
    column: [24, 24, 12, 8]
  },
  {
    visible: 'activity_code',
    field: 'activity_code',
    label: '活动编码',
    placeholder: '活动编码',
    component: 'input',
    disabled: false,
    column: [24, 24, 12, 8],
    prop: 'activity_code'
  },
  {
    visible: 'act_type',
    field: 'act_type',
    label: '活动目的',
    placeholder: '活动目的',
    component: 'dict',
    type: 'dataset',
    dict: 'activity',
    name: 'actType',
    clearable: true,
    column: [24, 24, 12, 8]
  },
  {
    visible: 'budget',
    field: 'budget',
    label: '活动预算',
    placeholder: '活动预算',
    component: 'input',
    type: 'number',
    column: [24, 24, 12, 8]
  },
  {
    visible: 'view_userid',
    field: 'view_userid',
    label: '浏览人',
    placeholder: '浏览人',
    component: 'mgSelect',
    multiple: true,
    constKey: 'view_userid',
    column: [24, 24, 12, 8]
  },
  {
    visible: 'creater_key',
    field: 'creater_key',
    label: '创建人绑定',
    placeholder: '创建人绑定',
    component: 'mgSelect',
    multiple: true,
    constKey: 'creater_key',
    column: [24, 24, 12, 8]
  },
  {
    visible: 'star_time',
    field: 'star_time',
    label: '开始时间',
    placeholder: '开始时间',
    component: 'time',
    clearable: true,
    column: [24, 24, 12, 8]
  },
  {
    visible: 'end_time',
    field: 'end_time',
    label: '结束时间',
    placeholder: '结束时间',
    component: 'time',
    clearable: true,
    column: [24, 24, 12, 8]
  },
  {
    visible: 'hope_country',
    field: 'hope_country',
    label: '意向国家',
    placeholder: '意向国家',
    component: 'select',
    multiple: true,
    constKey: 'countries',
    column: [24, 24, 12, 8]
  },
  {
    visible: 'act_remark',
    field: 'act_remark',
    label: '活动备注',
    placeholder: '活动备注',
    component: 'textarea',
    rows: 4,
    column: [24, 24, 24, 24]
  },
  {
    visible: 'act_data',
    field: 'act_data',
    label: '活动话术',
    placeholder: '活动话术',
    component: 'textarea',
    rows: 4,
    column: [24, 24, 24, 24]
  }
];

let formData = {
  act_title: '',
  id: 0,
  act_remark: '',
  act_data: '',
  creater_key: [],
  star_time: '',
  end_time: '',
  view_userid: [],
  act_status: 1,
  hope_country: [],
  budget: null,
  act_type: null
};

let constDict = {
  view_userid: []
};

export default {
  data() {
    return {
      options: [],
      constDict,
      formData: {},
      rules: {
        activity_code: [{ required: true, message: '活动编号不能为空', trigger: 'change' }]
      }
    };
  },
  components: { jmFormOptions },
  methods: {
    // 初始默认搜索值
    setFormData() {
      this.formData = Object.assign({}, formData);
    },
    setConstDict() {
      this.constDict = Object.assign({}, constDict);
    },
    reset() {
      this.setFormData();
    },
    save() {
      const { activity_code: activityCode } = this.formData;
      if (!activityCode || activityCode === '') {
        this.$message.error('活动编号不能为空');
      } else if (!/^[a-zA-Z0-9-_]+$/.test(activityCode)) {
        this.$message.error('活动编号格式不正确');
      } else {
        this.formData.site_name = this.$siteName;
        this.$http._post({
          url: '/index/general_activity/edit',
          data: this.formData
        })
          .then(({ result, msg }) => {
            if (result === -1) {
              this.$message.error(msg);
            } else {
              this.$message.success('保存成功');
              this.$router.push({ name: 'activityDataList' });
            }
          });
      }
    }
  },
  created() {
    this.reset();
    options[1].disabled = Boolean(parseInt(this.$route.params.id, 10));
    this.options = options;
    this.$http
      ._get({
        url: `/index/general_activity/show?id=${this.$route.params.id}`
      })
      .then(({ data }) => {
        if (typeof data.from_data !== 'undefined') {
          formData = data.from_data;
          this.setFormData();
        }
        this.constDict = data.const_dict;
      }, ({ data }) => {
        if (!data.const_dict) {
          this.$alert('数据问题', '', {
            confirmButtonText: '确定',
            callback: () => {
              this.$router.push({ name: 'editStudent', params: { id: this.$route.params.id } });
            }
          });
        }
      });
  },
  watch: {
  }
};
</script>
<style scoped>
</style>
